/*--------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * See License.txt in the project root for license information.
 *--------------------------------------------------------------*/
import { Node } from '@msdyn365-commerce-modules/utilities';
import * as React from 'react';
import {
    IBuyboxAddToCartViewProps,
    IBuyboxAddToOrderTemplateViewProps,
    IBuyboxAddToWishlistViewProps,
    IBuyboxKeyInPriceViewProps,
    IBuyboxProductConfigureDropdownViewProps,
    IBuyboxProductConfigureViewProps,
    IBuyboxProductQuantityViewProps,
    IBuyboxShopSimilarLookViewProps
} from '@msdyn365-commerce-modules/buybox/src/modules/buybox/../../common';
import { IBuyboxViewProps } from '@msdyn365-commerce-modules/buybox/src/modules/buybox/./buybox';
import { IBuyboxFindInStoreViewProps } from '@msdyn365-commerce-modules/buybox/src/modules/buybox/./components/buybox-find-in-store';
//import { getProductDimensions Async, getProductRefiners Async } from '../../../dataService/DataActionExtension.g';
import { AttributeValue, SimpleProduct } from '@msdyn365-commerce/retail-proxy';
import ReactHtmlParser from 'react-html-parser';
import { getAttributeValuesAsync } from '@msdyn365-commerce/retail-proxy/dist/DataActions/ProductsDataActions.g';
import { useState } from 'react';

//Commented out Description (the OOtB desc) since we're not using it for now.
const BuyboxView: React.FC<IBuyboxViewProps> = props => {
    const {
        /*MediaGalleryContainerProps,*/ ProductInfoContainerProps,
        addToCart,
        addToOrderTemplate,
        addToWishlist,
        configure,
        /*description,*/ findInStore,
        quantity,
        price,
        title,
        rating,
        inventoryLabel,
        shopSimilarLook,
        keyInPrice,
        shopSimilarDescription,
        unitOfMeasure
    } = props;

    const [productAttribute, setProductAttribute] = useState<AttributeValue[]>([]);
    // Get Attribute Call
    const _getAttriAsync = async (props: IBuyboxViewProps) => {
        const context = props.context.actionContext;
        const recordID: number = props.data.product.result?.RecordId!;
        const channelID = props.context.request.apiSettings.channelId;
        const catelogID = props.context.request.apiSettings.catalogId;
        const getAttribute: AttributeValue[] = await getAttributeValuesAsync({ callerContext: context }, recordID, channelID, catelogID);

        setProductAttribute(getAttribute);
    };
    // Product Attribute Rendering HTML
    const renderProductAttributes = () => {
        return (
            <>
                <h2 className='ms-product-specification__heading'>Product Attribtues</h2>
                <table className='ms-product-specification__table table-striped table-bordered'>
                    <tbody>
                        {productAttribute.map(attribute => (
                            <tr className='ms-product-specification__table-row'>
                                {attribute.TextValue !== '' && (
                                    <>
                                        <th scope='row'>{attribute.Name}</th>
                                        <td>{attribute.TextValue}</td>
                                    </>
                                )}
                            </tr>
                        ))}
                    </tbody>
                </table>
            </>
        );
    };

    React.useEffect(() => {
        _getAttriAsync(props);

        props.data.productDimensions.result?.forEach(dimension => {
            let dimension_type = dimension.DimensionTypeValue;
            let dimension_values: any = '';
            dimension.ExtensionProperties?.forEach(value => {
                if (value.Key == 'AllDimensions') {
                    dimension_values = value.Value?.StringValue;
                }
            });
            if (dimension_values !== '') {
                dimension_values = JSON.parse(dimension_values);
                inject_dimensions(dimension_values, dimension_type);
            }
        });

        function inject_dimensions(dimensions: any, type_dimension: any) {
            let dropDowns = document.getElementsByClassName('ms-buybox__dropdown');
            //Get the dropdown html by using ID
            const valves = document.getElementById('valves');
            const material = document.getElementById('material');
            for (let i = 0; i < dropDowns.length; i++) {
                let dropDown_for = dropDowns[i].firstElementChild?.getAttribute('for');
                let dimension_type;
                if (dropDown_for != null) {
                    let search_against = 'ms-buybox__dropown-quantity-input-';
                    dimension_type = dropDown_for.slice(dropDown_for.indexOf(search_against) + search_against.length);
                    if (dimensions !== undefined && dimension_type == type_dimension.toString()) {
                        let $element = dropDowns[i].lastChild as HTMLDivElement;
                        if ($element.classList.contains('msc-swatch-container')) {
                            //SWATCH
                            let $options = $element.children as HTMLCollection;
                            for (let z = 0; z < dimensions.length; z++) {
                                let is_exist = false;
                                for (let y = 0; y < $options.length; y++) {
                                    if ($options[y].textContent == dimensions[z].VALUE) {
                                        is_exist = true;
                                        //Remove duplicate
                                        if ($options[y].textContent == material?.textContent) {
                                            material && material.remove();
                                        }
                                    }
                                }
                                if (is_exist === false) {
                                    //PUSH the value
                                    let option_elem = document.createElement('button');
                                    option_elem.textContent = dimensions[z].VALUE;
                                    option_elem.setAttribute('disabled', '');
                                    option_elem.classList.add('msc-swatch-container__item');
                                    option_elem.classList.add('msc-swatch-container__item__unselected');
                                    option_elem.classList.add('msc-swatch-container__item__uncolored');
                                    option_elem.setAttribute('id', 'material');
                                    $element.appendChild(option_elem);
                                }
                            }
                        } else {
                            //DROPDOWN
                            let $select = dropDowns[i].lastChild as HTMLSelectElement;
                            let $options = $select.options as HTMLOptionsCollection;
                            for (let z = 0; z < dimensions.length; z++) {
                                let is_exist = false;
                                for (let y = 0; y < $options.length; y++) {
                                    if ($options[y].text == dimensions[z].VALUE) {
                                        is_exist = true;
                                        //Remove duplicate
                                        if ($options[y].text == valves?.textContent) {
                                            valves && valves.remove();
                                        }
                                    }
                                }
                                if (is_exist === false) {
                                    //PUSH the value in the dropDown
                                    let option_elem = document.createElement('option');
                                    option_elem.text = dimensions[z].VALUE;
                                    option_elem.setAttribute('disabled', '');
                                    option_elem.setAttribute('id', 'valves');
                                    $select.options.add(option_elem);
                                }
                            }
                        }
                    }
                }
            }
        }
    });
    return (
        <div id='pdp' className='row mb-3 mb-lg-5'>
            <div className='col-sm-7 col-md-6 col-lg-8 col-xl-7 col-hd-8 pos-initial'>
                <div className='ms-buybox__media-gallery'>{props.mediaGallery}</div>
                <Node {...ProductInfoContainerProps}>
                    <div className='ms-buybox__details'>
                        {title}
                        {_renderSearchName(props.data.product.result)}
                        {_renderLevelScale(props, props.data.product.result)}
                        <div className='d-flex'>
                            {_showPrice(props.data.product.result) && price}
                            {_renderCurrencyCode(props.data.product.result)}
                        </div>
                        {_renderSocialShare(props.slots && props.slots.socialShare)}
                        {configure && _renderConfigure(configure, props)}
                        {unitOfMeasure}
                        {props.bulkPurchaseLink}
                        {/*{description}*/}
                        {rating}
                        {/*{getProductDimensions(props.context.actionContext.requestContext, "PM-102")}*/}
                        {keyInPrice && _renderKeyInPrice(keyInPrice)}
                        {quantity && _renderQuantity(quantity)}
                        {inventoryLabel}
                        {addToCart && _renderAddToCart(addToCart)}
                        {findInStore && _renderFindInStore(findInStore)}
                        {addToOrderTemplate && _renderAddToOrderTemplate(addToOrderTemplate)}
                        {addToWishlist && _renderAddToWishlist(addToWishlist)}
                        {shopSimilarLook && _renderShopSimilarItem(shopSimilarLook)}
                        {shopSimilarDescription && _renderShopSimilarItem(shopSimilarDescription)}
                        <hr className='my-3' />
                        <a className='msc-btn w-100' href='/dealer-locator'>
                            Find a Dealer
                        </a>
                    </div>
                </Node>
                {_renderLongFields(props.data.product.result)}
                {productAttribute && renderProductAttributes()}
            </div>
        </div>
    );
};

//Loop through the 40+ ExtensionProperties only once (vs 3 times), & then map the 1-3 saved elements to the page.
const _renderLongFields = (product: SimpleProduct | undefined) => {
    if (product !== undefined) {
        const _vals: Array<string> = ['ProductDescription', 'ProductFeatures', 'ProductSpecification'];
        const _titles: Array<string> = ['Description', 'Features', 'Specifications'];
        let _results: JSX.Element[] = []; //create an empty array for stringified HTML
        //check for our three sought-after values, and then use the associated title
        product.ExtensionProperties?.forEach(element => {
            if (_vals.includes(element.Key as string) && element.Value?.StringValue) {
                _results.push(_renderCollapse(element.Value.StringValue, _titles[_vals.indexOf(element.Key as string)]));
            }
        });
        return <div>{_results.map(item => item)}</div>;
    } else {
        return <></>;
    }
};

const _renderCollapse = (html: string, title: string) => {
    return (
        <div className='mb-3 mb-lg-5'>
            <h2 className='h6 mb-2'>{title}</h2>
            {ReactHtmlParser(html)}
        </div>
    );
    //Didn't want to totally remove the collapse incase we need to revert
    /*if(html.length >= 300){
		return (
			<div className="clps-short">
				<hr className="my-3"/>
				<h2 className="h6 mb-2">{title}</h2>
				<div className="content">
					{ReactHtmlParser(html)}
				</div>
				<div className="d-flex jc-center">
					<button className="show-btn" onClick={_showMoreButtonClick}></button>
				</div>
			</div>
		)
	} else {
		return (
			<>
				<hr className="my-3"/>
				<h2 className="h6 mb-2">{title}</h2>
				{ReactHtmlParser(html)}
			</>
		)
	}*/
};
//Didn't want to totally remove the collapse incase we need to revert
/*const _showMoreButtonClick = (e:React.MouseEvent<HTMLButtonElement>) => {
	e.stopPropagation();
	console.log(e.currentTarget.closest('.clps-short')?.classList.toggle('show'));
}*/

const _renderSearchName = (product: SimpleProduct | undefined) => {
    let searchName = '';
    if (product != undefined) {
        product.ExtensionProperties?.forEach(element => {
            if (element.Key == 'SearchName' && element.Value?.StringValue != undefined) {
                searchName = element.Value?.StringValue;
            }
        });
    }
    return <h2 className='ms-buybox__search-name h5 text-muted'>{searchName}</h2>;
};

const _renderCurrencyCode = (product: SimpleProduct | undefined) => {
    let _currencyCode = '';
    if (product != undefined) {
        product.ExtensionProperties?.forEach(element => {
            if (element.Key == 'CurrencyCode' && element.Value?.StringValue != '' && element.Value?.StringValue != undefined) {
                _currencyCode = element.Value?.StringValue;
            }
        });
    }
    return <span className={'currency ' + _currencyCode.toLowerCase()}>{_currencyCode}</span>;
};

const _renderLevelScale = (props: IBuyboxViewProps, product: SimpleProduct | undefined) => {
    let scaleLevel = null;
    let scaleClass = null;
    if (product != undefined) {
        product.ExtensionProperties?.forEach(element => {
            if (element.Key == 'LevelId' && element.Value?.StringValue != undefined) {
                scaleLevel = element.Value?.StringValue;
                scaleClass = element.Value?.StringValue?.toLocaleLowerCase();
            }
        });

        // Check if Product Sticker is available or not
        if(scaleLevel != null)
        {
            return <div className={'bb_product-level ' + scaleClass}>{scaleLevel}</div>;
        }
        else{
            return null;
        }
        //end
       
    } else {
        return <div className={'bb_product-level ' + scaleClass}>{scaleLevel}</div>;
    }
};

const _showPrice = (product: SimpleProduct | undefined) => {
    let showPrice: boolean = true;
    if (product != undefined) {
        product.ExtensionProperties?.forEach(element => {
            if (element.Key == 'IsSupressPrice' && element.Value?.BooleanValue == true) {
                showPrice = false;
            }
        });
    }
    return showPrice;
};

const _renderAddToCart = (addToCart: IBuyboxAddToCartViewProps): JSX.Element => {
    const { ContainerProps, errorBlock, button } = addToCart;

    return (
        <Node {...ContainerProps}>
            {errorBlock}
            {button}
        </Node>
    );
};

const _renderAddToOrderTemplate = (addToOrderTemplate: IBuyboxAddToOrderTemplateViewProps): JSX.Element => {
    const { ContainerProps, errorBlock, button } = addToOrderTemplate;

    return (
        <Node {...ContainerProps}>
            {errorBlock}
            {button}
        </Node>
    );
};

const _renderAddToWishlist = (addToWishlist: IBuyboxAddToWishlistViewProps): JSX.Element => {
    const { ContainerProps, errorBlock, button } = addToWishlist;

    return (
        <Node {...ContainerProps}>
            {errorBlock}
            {button}
        </Node>
    );
};

const _renderConfigure = (configure: IBuyboxProductConfigureViewProps, parent_props: IBuyboxViewProps): JSX.Element => {
    const { ContainerProps, dropdowns } = configure;
    return (
        <Node {...ContainerProps}>
            {/* {dropdowns.map(_renderConfigureDropdown, productDimension)} */}
            {dropdowns.map((dropdown, i) => {
                return _renderConfigureDropdown(dropdown, parent_props, i);
            })}
        </Node>
    );
};

const _renderSocialShare = (socialShare: React.ReactNode[]): JSX.Element | undefined => {
    if (!socialShare || socialShare.length === 0) return undefined;
    return (
        <>
            {socialShare[0]}
            <hr className='my-3' />
        </>
    );
};

const _renderConfigureDropdown = (
    dropdown: IBuyboxProductConfigureDropdownViewProps,
    parent_props: IBuyboxViewProps,
    counter: any
): JSX.Element => {
    const { ContainerProps, LabelContainerProps, heading, errors, select } = dropdown;
    let productDimensionColor = '';
    let productDimensionSize = '';
    let productDimensionType = '';
    //console.log(dropdown.select == '<div>Color</div>');
    let product = parent_props.data.product.result;
    if (product != undefined) {
        product.ExtensionProperties?.forEach(element => {
            if (element.Key == 'DimensionOne' && element.Value?.StringValue != undefined) {
                productDimensionColor = element.Value?.StringValue;
            }
            if (element.Key == 'DimensionThree' && element.Value?.StringValue != undefined) {
                productDimensionSize = element.Value?.StringValue;
            }
            if (element.Key == 'DimensionFour' && element.Value?.StringValue != undefined) {
                productDimensionType = element.Value?.StringValue;
            }
        });
        return (
            <Node {...ContainerProps}>
                <Node {...LabelContainerProps}>
                    {counter == 0 && productDimensionColor != ''
                        ? productDimensionColor
                        : counter == 1 && productDimensionSize != ''
                        ? productDimensionSize
                        : counter == 2 && productDimensionType != ''
                        ? productDimensionType
                        : heading}
                    {errors}
                </Node>
                {select}
            </Node>
        );
    } else {
        return (
            <Node {...ContainerProps}>
                <Node {...LabelContainerProps}>
                    {counter == 0 && productDimensionColor != ''
                        ? productDimensionColor
                        : counter == 1 && productDimensionSize != ''
                        ? productDimensionSize
                        : counter == 2 && productDimensionType != ''
                        ? productDimensionType
                        : heading}
                    {errors}
                </Node>
                {select}
            </Node>
        );
    }
};

const _renderFindInStore = (findInStore: IBuyboxFindInStoreViewProps): JSX.Element => {
    const { ContainerProps, storeSelector, heading, description, errors, button, modal, productPickupOptionList } = findInStore;
    return (
        <Node {...ContainerProps}>
            {storeSelector}
            {heading}
            {productPickupOptionList}
            {description}
            {errors}
            {button}
            {modal}
        </Node>
    );
};

const _renderQuantity = (quantity: IBuyboxProductQuantityViewProps): JSX.Element => {
    const { ContainerProps, LabelContainerProps, heading, input, errors } = quantity;
    return (
        <Node {...ContainerProps}>
            <Node {...LabelContainerProps}>
                {heading}
                {errors}
            </Node>
            {input}
        </Node>
    );
};

const _renderKeyInPrice = (keyInPrice: IBuyboxKeyInPriceViewProps): JSX.Element => {
    const { ContainerProps, LabelContainerProps, heading, input } = keyInPrice;
    return (
        <Node {...ContainerProps}>
            <Node {...LabelContainerProps}>{heading}</Node>
            {input}
        </Node>
    );
};

const _renderShopSimilarItem = (shopSimilarItem: IBuyboxShopSimilarLookViewProps): JSX.Element => {
    const { ContainerProps, errors, input } = shopSimilarItem;
    return (
        <Node {...ContainerProps}>
            {errors}
            {input}
        </Node>
    );
};
export default BuyboxView;
